module.exports = __webpack_public_path__ + "static/media/notebook02.93152d7b.jpg";